import { Avatar } from '@mui/material';
import moment from 'moment/moment';
import DOMPurify from 'dompurify';

export const DetailsContainer = ({
  title,
  subtitle,
  summary,
  startDate,
  endDate,
  color,
  current,
}) => {
  const formatDate = (date) =>
    date ? moment(date).format('MMM YYYY') : 'Not specified';

  const dates = startDate
    ? `${formatDate(startDate)} - ${current ? 'PRESENT' : formatDate(endDate)}`
    : null;
  return (
    <>
      <Avatar
        sx={{
          bgcolor: 'pink',
          color: `${color}`,
          width: 32,
          height: 32,
          left: 0,
          position: 'absolute',
          top: '14px',
        }}
      >
        {title.charAt(0)}
      </Avatar>
      <div className="flex space-x-5 items-center">
        <h4 className="text-xl font-semibold">{title}</h4>
        <span className={`text-[${color}] font-semibold text-sm`}>{dates}</span>
      </div>
      <div>
        <p className={`text-[${color}] text-sm`}>{subtitle}</p>
      </div>
      <div className="mt-5">
        <div
          className="text-[#77838F] text-sm listType"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(summary) }}
        />
      </div>
    </>
  );
};
